import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;
export const TOKEN_KEY = "phm_token";

// NOTE on token storage:
// We use sessionStorage (cleared when the browser tab closes) instead of localStorage
// to reduce XSS persistence risk. The backend also sets httpOnly cookies as a fallback —
// once deployed on the user's own domain with proper CORS (not the preview's edge "*"),
// the cookie path will automatically take over and tokens can be removed from JS storage.
export const tokenStore = {
  get: () => sessionStorage.getItem(TOKEN_KEY),
  set: (t) => sessionStorage.setItem(TOKEN_KEY, t),
  clear: () => sessionStorage.removeItem(TOKEN_KEY),
};

export const api = axios.create({
  baseURL: API,
  // Don't send credentials on this platform — edge CORS is "*" which blocks
  // credentialed requests. Auth uses Bearer token from sessionStorage instead.
  // On production domain with proper CORS, this can be flipped to true to use cookies.
  withCredentials: false,
});

api.interceptors.request.use((config) => {
  const token = tokenStore.get();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
